import { render } from "./checkout-area.vue?vue&type=template&id=0f9a6e7a&scoped=true"
import script from "./checkout-area.vue?vue&type=script&lang=js"
export * from "./checkout-area.vue?vue&type=script&lang=js"

import "./checkout-area.vue?vue&type=style&index=0&id=0f9a6e7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9a6e7a"]])

export default __exports__